var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teka-container"},[(_vm.tekaUrl)?_c('iframe',{attrs:{"src":_vm.tekaUrl}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }